import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorAlertComponent } from '../components/error-alert/error-alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private _snackBar: MatSnackBar) { }

  openSnackBar(message: string, action: string ='close', duration: number = 10000) {
    this.infoAlert(message, action)
  }

  errorAlert(message: string, showDetails: boolean = false, duration: number = 10000) {
    this._snackBar.openFromComponent(ErrorAlertComponent,
      {
        duration: duration,
        data: {
          message,
          action: 'close',
          type: 'error',
          showDetails
        }
      });
  }

  warningAlert(message: string, duration: number = 10000) {
    this._snackBar.openFromComponent(ErrorAlertComponent,
      {
        duration: duration,
        data: {
          message,
          action: 'close',
          type: 'warn'
        }
      });
  }


  infoAlert(message: string, action: string = 'close', duration: number = 10000) {
    this._snackBar.openFromComponent(ErrorAlertComponent,
      {
        duration: duration,
        data: {
          message,
          action: action,
          type: 'info'
        }
      });
  }
}
